import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './index.scss';
import { t } from 'services/translation';

const { string, array, func } = PropTypes;

class NPS extends React.Component {
  static propTypes = {
    items: array.isRequired,
    onClick: func.isRequired,
    selectedValue: string,
  };

  itemClicked(itemValue, e) {
    this.props.onClick(itemValue);
  }

  hasError() {
    return this.props.errors && this.props.errors.length > 0;
  }

  renderError() {
    if (this.hasError()) {
      return <span className="number-error">{this.props.errors[0]}</span>;
    }
    return null;
  }

  render() {
    const NPSWrapperClasses = classnames('nps-wrapper', {
      error: this.hasError(),
    });
    const numberarray = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10',
    ];
    return (
      <div className={NPSWrapperClasses}>
        <div className="nps-label">
          <span className="nps-zero">{t('NOT_AT_ALL_LIKELY')}</span>
          <span className="nps-ten">{t('EXTREMELY_LIKELY')}</span>
        </div>
        <div
          className="nps-number-wrapper"
          data-testid={this.props['data-testid']}
        >
          {numberarray.map((x) => {
            const cssClass =
              this.props.selectedValue === x
                ? 'number selected brand-bg'
                : 'number';
            return (
              <div
                key={x}
                onClick={this.itemClicked.bind(this, x)}
                className="number-item"
              >
                <span className="number-wrapper">
                  <i className={cssClass} data-testid="number-selected">
                    {x}
                  </i>
                </span>
              </div>
            );
          })}
        </div>
        {this.renderError()}
      </div>
    );
  }
}

export default NPS;
